import React, { useCallback } from 'react';
import Box from 'fe-design-base/atoms/Box';
import Text from 'fe-design-base/atoms/Text/Text';
import NumberAsStringField from 'fe-design-base/molecules/NumberAsStringField';
import { useFormikContext } from 'formik';

import ChipGroupField from 'features/team/components/ChipGroup/ChipGroupField';
import {
  ACCOUNT_TYPE_OPTIONS,
  ROUTING_NUMBER_LENGTH,
} from 'features/team/components/TaxEntryForm/constants';
import {
  TAX_ENTRY_PAYMENT_METHOD_ERROR_PATH,
  TAX_ENTRY_PAYMENT_METHOD_PATH,
} from 'features/team/constants';

import { toI18n } from 'util/i18n';
import { isValidRoutingNumber } from 'util/validators';

const BankingInformationForm = () => {
  const { values } = useFormikContext();

  const validateRoutingNumber = useCallback(() => {
    if (values.decrypted_routing_number?.length !== ROUTING_NUMBER_LENGTH)
      return;
    const result = isValidRoutingNumber(
      toI18n(`${TAX_ENTRY_PAYMENT_METHOD_ERROR_PATH}.invalid_routing_number`)
    )(values.decrypted_routing_number);
    return result;
  }, [values.decrypted_routing_number]);

  return (
    <Box>
      <Box spacebetween mt={32}>
        <Box w={275}>
          <NumberAsStringField
            name="decrypted_account_number"
            hasAsterisk
            label={toI18n(`${TAX_ENTRY_PAYMENT_METHOD_PATH}.account_number`)}
          />
        </Box>
        <Box w={275}>
          <NumberAsStringField
            name="decrypted_reentered_account_number"
            hasAsterisk
            label={toI18n(
              `${TAX_ENTRY_PAYMENT_METHOD_PATH}.reenter_account_number`
            )}
          />
        </Box>
      </Box>
      <Box mt={8}>
        <Box w={275}>
          <NumberAsStringField
            name="decrypted_routing_number"
            hasAsterisk
            label={toI18n(`${TAX_ENTRY_PAYMENT_METHOD_PATH}.routing_number`)}
            validate={validateRoutingNumber}
          />
        </Box>
      </Box>

      <Box mt={16}>
        <Text color="mono900" variant="bodyBold" className="required">
          {toI18n(`${TAX_ENTRY_PAYMENT_METHOD_PATH}.account_type`)}
        </Text>

        <Box mt={10}>
          <ChipGroupField
            name="bank_account_type"
            options={ACCOUNT_TYPE_OPTIONS}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default BankingInformationForm;
